module.exports = __webpack_public_path__ + "static/media/badboys.51430c2c.jpg";